import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {of as observableOf,  Observable ,  BehaviorSubject ,  Subject } from 'rxjs';

import { FlowInstance } from "../../flow//models/flow.model";
import { genId } from "../../core/services/genId";
import { Note, NotesData } from '../models/note.model';
import { NoteRelatedItemType } from '../models/note_relatedItemType.enum';
import { StateType } from '../models/flow.dto';



@Injectable()
export class NoteService {

    readonly NOTES_URL = '/api/notes';
    noteAdded$ = new Subject<Note>();
    note$ = new BehaviorSubject<NotesData>({data: [], history: [], reviewNotes: [], workItems: [] });
    workflowId: string;

    constructor(public http: HttpClient) { }

    getNotes(relatedItemIds: string, relatedItemType: NoteRelatedItemType): Observable<Array<Note>> {
        if (!relatedItemIds) return observableOf([]);
        var path = `${this.NOTES_URL}/${relatedItemIds}/${relatedItemType}`;
        return this.http.get<Array<Note>>(path);
    }

    newNote(args: { data: any, reviewNotes: any, instance: FlowInstance, stateType: StateType, onBehalf?: boolean }): Observable<boolean> {
        this.workflowId = args.instance.id;
        let obs = new Subject<boolean>();

        this.note$.next({
            currentWorkItem: args.instance.currentWorkItem,
            history: args.instance.history,
            workItems: args.instance.associatedWorkItems,
            stateType: args.stateType,
            data: args.data,
            showNotes: true,
            reviewNotes: args.reviewNotes,
            workflowId: args.instance.id,
            flowOnBehalf: (args.onBehalf != null && args.onBehalf),
            obs: obs
        } as NotesData);

        return obs.asObservable();
    }

    postNote(note: Note): Observable<Note> {
        if (!note.id) note.id = genId();
        return this.http.post<Note>(this.NOTES_URL, note);
    }
}
